// extracted by mini-css-extract-plugin
export default {"bar":"Guage_bar__vEGr3","arrow":"Guage_arrow__YUex8","progressText":"Guage_progressText__-mIkX"};